import React from 'react';
import { Box, ToggleButton, Typography } from '@mui/material';
import Apple from '@mui/icons-material/Apple';
import WatchOutlined from '@mui/icons-material/WatchOutlined';
import RadioButtonUnchecked from '@mui/icons-material/RadioButtonUnchecked';
import { collectionSources, CollectionSourceId, visibleCollectionSources } from '../../../config/collectionSources';

const icons = { fitbit: WatchOutlined, healthkit: Apple, ultrahuman: RadioButtonUnchecked };
export default function CollectionSourcePicker({ value, onChange }: { value: CollectionSourceId; onChange: (value: CollectionSourceId) => void }) {
  return <Box role="group" aria-label="Export data source" sx={{ display: 'grid', gridTemplateColumns: `repeat(${visibleCollectionSources.length}, minmax(0, 1fr))`,
    gap: 1, width: '100%', maxWidth: { sm: visibleCollectionSources.length * 160 } }}>
    {visibleCollectionSources.map(id => {
      const Icon = icons[id], source = collectionSources[id];
      return <ToggleButton key={id} value={id} selected={value === id} aria-label={source.label} onClick={() => onChange(id)}
        sx={{ minWidth: 0, py: .75, px: 1.5, gap: 1, textTransform: 'none', borderRadius: '10px', borderColor: 'divider',
          '&.Mui-selected': { bgcolor: '#fcf5f5', borderColor: 'primary.main', boxShadow: 'inset 0 0 0 1px currentColor', color: 'primary.main' } }}>
        <Icon sx={{ fontSize: 20 }} /><Typography sx={{ fontSize: 14, fontWeight: 600 }}>{source.label}</Typography>
      </ToggleButton>;
    })}
  </Box>;
}
